module.exports = __webpack_public_path__ + "static/macbook.5ebea65a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/tools/macbook.jpg
// module id = 1101
// module chunks = 101179379639045